<template>
<div>
	<WindowForSetting @Close="close" ref="Window" class="stationId" :bg="true">
		<div slot="head" class="head bg">
			
			<!-- // @click="backTopLevel" -->
			<span class="title mt05x fs12x curP" v-if="level==1">{{getLanguageStr('word1721','电站设置')}}</span>
			<span class="fs12x" v-else>
			<button type="button" class="mr1x" @click="backTopLevel">
				<Icon name="more" class="w1x fSub transform" :sizeBase="'m'" /></button>
				{{config.name}}
			</span>
			<!-- <div class="fR cField fField hover-f-main_E hover-c-main_E tra-fast_E vaM_E">
				<button class="close close-ico bgClose style-close tra-fast hover-f-error" :title="$t('cmd153',['关闭'])" @click="close" type="button"><svg class="ico"><use xlink:href="#ico-close" /></svg></button>
			</div> -->
			<!-- <button type="button" class="fR cField" @click="refreshCrawl" :title="$t('cmd7',['刷新'])" v-if="crawlShow==true">
				<div class="ico fa fa-refresh "></div>
			</button> -->
		</div>
		<div fillHeight="lastHeight" scroll>
			
			<ul class="config-list" v-show="level == 1">
				<li v-for="(btn,index) in configBtnList" :key="index" @click="goNext(2,btn)" class="lh13"><a><span class="fR mr2x"><Icon name="arrow-r" class="fSub w1x h1x"/></span><span>{{btn.name}}</span></a></li>
				<!-- v-if="gridInterconnectionType=='EXCESS'?index<configBtnList.length:index<configBtnList.length-1" -->
			</ul>
			<div v-show="level === 2">
				<!-- 数据来源设置 -->
				
				<div class="source" v-if="config.key === 'source'">
					<StationSourceConfig ref="sourceConfig" @close="backTopLevel" @refresh="$emit('refreshOffset')"  @configAll="configAll" :powerType="powerType"></StationSourceConfig>
				</div>
				 <div v-show="config.key === 'offset'">
				 	<!--偏移量设置-->
				 	<ul class="config-list">
						<li v-for="(btn,index) in offsetBtnList" :key="index" @click="goNext(3,btn)">
							<a><span class="fR mr1x"><span v-if="index===0" class="mr1x">{{globalOffset}}kwh</span><Icon name="arrow-r" class="fSub w1x h1x"/></span><span>{{btn.name}}</span></a><!--累计发电量偏移量-->
						</li>
					</ul>
				</div> 
				<!--累计发电量偏移量-->
				<div v-show="config.key ==='calcMethods'">
					<ul class="config-list" >
						<li v-for="(btn,index) in tempCalcBtnList" :key="index" @click="goNext(3,btn)" class="cb">
							<a class="flex">
								{{btn.name}}
								<span class="fc1">
									<span v-show="cumulativeElectricMethod=='TOTAL_FROM_DEVICE_UPLOAD'&&index==0">{{getLanguageStr('word1824','通过设备上传的累计发电量数据求和计算')}}</span>
									<span v-show="cumulativeElectricMethod=='TOTAL_DAILY_SUM'&&index==0">{{getLanguageStr('word1825','通过电站日发电量求和计算')}}</span>
									<span v-show="electricityConsumptionMethod=='TOTAL_FROM_DEVICE_UPLOAD'&&index==1">{{getLanguageStr('plant379','通过设备上传的累计用电量数据求和计算')}}</span>
									<span v-show="electricityConsumptionMethod=='TOTAL_DAILY_SUM'&&index==1">{{getLanguageStr('plant380','通过电站日用电量求和计算')}}</span>
									<span v-show="electricityPurchaseMethod=='TOTAL_FROM_DEVICE_UPLOAD'&&index==2">{{getLanguageStr('plant382','通过设备上传的累计购电量数据求和计算')}}</span>
									<span v-show="electricityPurchaseMethod=='TOTAL_DAILY_SUM'&&index==2">{{getLanguageStr('plant383','通过电站日购电量求和计算')}}</span>
									<span v-show="gridInterconnectionMethod=='TOTAL_FROM_DEVICE_UPLOAD'&&index==3">{{getLanguageStr('plant385','通过设备上传的累计并网量数据求和计算')}}</span>
									<span v-show="gridInterconnectionMethod=='TOTAL_DAILY_SUM'&&index==3">{{getLanguageStr('plant386','通过电站日并网量求和计算')}}</span>
									<span v-show="chargingElectricityMethod=='TOTAL_FROM_DEVICE_UPLOAD'&&index==4">{{getLanguageStr('plant388','通过设备上传的累计充电量数据求和计算')}}</span>
									<span v-show="chargingElectricityMethod=='TOTAL_DAILY_SUM'&&index==4">{{getLanguageStr('plant389','通过电站日充电量求和计算')}}</span>
									<span v-show="dischargeElectricityMethod=='TOTAL_FROM_DEVICE_UPLOAD'&&index==5">{{getLanguageStr('plant391','通过设备上传的累计放电量数据求和计算')}}</span>
									<span v-show="dischargeElectricityMethod=='TOTAL_DAILY_SUM'&&index==5">{{getLanguageStr('plant392','通过电站日放电量求和计算')}}</span>
								</span>
								<Icon name="arrow-r" class="fSub w1x h1x"/>
							</a>
						</li>
					</ul>
				</div>
				<div class="python" v-if="config.key === 'python'">
					<SatationPython ref="crawl" @goBack="backTopLevel"></SatationPython>
				</div>
				<div class="plan" v-if="config.key === 'plan'">
					<StationPlanConfig ref="plan" @afterSave="backTopLevel" @goBack="backTopLevel"></StationPlanConfig>
				</div>
				<div class="proportion" v-if="config.key === 'proportion'">
					<StationProportionConfig ref="proportion" @refresh="refreshProportion"></StationProportionConfig>
				</div>
			</div>
			<div v-show="level == 3">
				<!--累计发电量计算方法-->
				<div v-show="config.relationship===1" class="pl4x radio-wrap">
					<div v-show="config.key=='methods'">
						<radio class="mt1x mb2x" name="method" v-model="cumulativeElectricMethod" label="TOTAL_FROM_DEVICE_UPLOAD">{{getLanguageStr('word1824','通过设备上传的累计发电量数据求和计算')}}</radio>
					    <radio class="mb1x" name="method" v-model="cumulativeElectricMethod" label="TOTAL_DAILY_SUM">{{getLanguageStr('word1825','通过电站日发电量求和计算')}}</radio>
				    </div>
					<div v-show="config.key=='useMethods'">
						<radio class="mt1x mb2x" name="method" v-model="electricityConsumptionMethod" label="TOTAL_FROM_DEVICE_UPLOAD">{{getLanguageStr('plant379','通过设备上传的累计用电量数据求和计算')}}</radio>
					    <radio class="mb1x" name="method" v-model="electricityConsumptionMethod" label="TOTAL_DAILY_SUM">{{getLanguageStr('plant380','通过电站日用电量求和计算')}}</radio>
					</div>
					<div v-show="config.key=='purchaseMethods'">
						<radio class="mt1x mb2x" name="method" v-model="electricityPurchaseMethod" label="TOTAL_FROM_DEVICE_UPLOAD">{{getLanguageStr('plant382','通过设备上传的累计购电量数据求和计算')}}</radio>
					    <radio class="mb1x" name="method" v-model="electricityPurchaseMethod" label="TOTAL_DAILY_SUM">{{getLanguageStr('plant383','通过电站日购电量求和计算')}}</radio>
					</div>
					<div v-show="config.key=='interconnectionMethods'">
						<radio class="mt1x mb2x" name="method" v-model="gridInterconnectionMethod" label="TOTAL_FROM_DEVICE_UPLOAD">{{getLanguageStr('plant385','通过设备上传的累计并网量数据求和计算')}}</radio>
					    <radio class="mb1x" name="method" v-model="gridInterconnectionMethod" label="TOTAL_DAILY_SUM">{{getLanguageStr('plant386','通过电站日并网量求和计算')}}</radio>
					</div>
					<div v-show="config.key=='fullMethods'">
						<radio class="mt1x mb2x" name="method" v-model="chargingElectricityMethod" label="TOTAL_FROM_DEVICE_UPLOAD">{{getLanguageStr('plant388','通过设备上传的累计充电量数据求和计算')}}</radio>
					    <radio class="mb1x" name="method" v-model="chargingElectricityMethod" label="TOTAL_DAILY_SUM">{{getLanguageStr('plant389','通过电站日充电量求和计算')}}</radio>
					</div>
					<div v-show="config.key=='dischargeMethods'">
						<radio class="mt1x mb2x" name="method" v-model="dischargeElectricityMethod" label="TOTAL_FROM_DEVICE_UPLOAD">{{getLanguageStr('plant391','通过设备上传的累计放电量数据求和计算')}}</radio>
					    <radio class="mb1x" name="method" v-model="dischargeElectricityMethod" label="TOTAL_DAILY_SUM">{{getLanguageStr('plant392','通过电站日放电量求和计算')}}</radio>
					</div>
					<div class="taC">
						<button class="sizeM bdSub boxR hover-bg-highLight w9x mt3x mr2x" type="button" @click="cancelCalcMethods">{{$t('cmd85',['取消'])}}</button>
				    		<button class="functionBtn w9x mt3x sizeM" type="button" @click="saveCalcMethods">{{$t('cmd84',['保存'])}}</button>
					</div>
				</div>
				<!--偏移量中某个点具体设置-->
				<station-offset-config :powerType="powerType" :stationId='stationId' :hAddShowFlag="addShowFlag" @addShowCalc="addShowCalc" v-show="config.relationship===2" :chooseType="config.key" ref="offsetConfig" :loading="loadingFlag" :basicInfo="basicInfo" :req="requestData" :total="globalOffset" :dayList="dayList"  :totalDay="totalDayOffset" @configAll="configAll" ></station-offset-config>
			</div>
		</div>
	</WindowForSetting>
</div>
</template>
<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as lib from '@/util/lib'
import WindowForSetting from '@/components/common/ui/WindowForView'
import Radio from '@/components/common/ui/Radio.vue'
import {StationMeteringSetting, StationMetering,StationMeteringMethod} from '@/api/maintain/plant/list'
import {getLanguageStr} from '@/util/language'
import * as configApi from '@/api/maintain/config'
import StationOffsetConfig from './StationOffsetConfig'
import StationSourceConfig from './StationSourceConfig'
import StationPlanConfig from './StationPlanConfig'
import StationProportionConfig from './StationProportionConfig'
import SatationPython from './StationPython'

export default {
  name: 'stationConfig',
  props: {
    basicInfo:{
      type:Object,
      default: () => ({})
    },
    assionInfo:{
      type:Object,
      default: () => ({})
    },
    powerType:{//能源类型light,wind
      type:String,
      default:"light"
    }
  },
  components: {
    WindowForSetting,
    StationOffsetConfig,
    StationSourceConfig,
    StationPlanConfig,
    StationProportionConfig,
    SatationPython,
    Radio
  },
  data () {
    return {
      // id:"stationConfig"+Math.round(Math.random()*99999),
      calcBtnList:[
      	{name:getLanguageStr('word1823','累计发电量计算方法'),key:'methods',relationship:1}
      ],
      tempCalcBtnList:[],
      offsetBtnList:[
			{name: getLanguageStr('plant330','累计发电量偏移量'),key:'offsetTotal',relationship:2},
			{name: getLanguageStr('word1981','日发电量偏移量'),key:'offsetDay',relationship:2}
		],
      configBtnList: [
        {name: getLanguageStr('word1722', '数据来源设置'), key: 'source',relationship:0},
        {name: getLanguageStr('word1908','累计电量计算方式'),key:'calcMethods',relationship:1},
        {name: getLanguageStr('word1192','偏移量'),key:'offset',relationship:2}
        //{name: getLanguageStr('word1373+cmd16','外部数据设置'), key:'python'},
       //{name: getLanguageStr('word1368+cmd16','计划发电量设置'), key:'plan'}
        //{name: getLanguageStr('word1382+cmd16','自发自用比例来源设置'), key:'proportion'}
      ],
      stationId: 0,
      requestData: {
        totalOffset: '',
        dayOffset: ''
      },
      gridInterconnectionType: '',
      typeOf: '',
      // activeIndex:{
      // 	generationAvailable:0,
      // 	utilityAvailable:0,
      // 	consumptionAvailable:0
      // },
      // selectHint:{
      // 	generationAvailable:[],//发电
      // 	utilityAvailable:[],//电网
      // 	consumptionAvailable:[]//用电
      // },
      dayList: [],
      loadingFlag: false,
      globalOffset: null,//累计发电量偏移量
      totalDayOffset: null,
      errMsg: {
        allOffset: {
          msg: '',
          show: false,
          msgs: [getLanguageStr('plant300', '偏移量不能为空')]
        },
        dayOffset: {
          msg: '',
          show: false,
          msgs: [getLanguageStr('plant300', '偏移量不能为空')]
        }
      },
      cumulativeElectricMethod:null,//发电量
      electricityConsumptionMethod:null,//用电量
      electricityPurchaseMethod:null,//购电量
      gridInterconnectionMethod:null,//并网量
      chargingElectricityMethod:null,//充电量
      dischargeElectricityMethod:null,//放电量
      addShowFlag:null
      // repeatData:{},//数据来源设置
      // isHint:true
    }
  },
    computed: {
    ...mapGetters({
      // stationId: 'stationDetail/stationId',
      config: 'stationConfig/config',
      level: 'stationConfig/level',
      metering: 'stationDetail/metering',
      crawlShow: 'stationConfig/crawlShow'
    })
    // subTitle() {
    // 	let {name} = this.config
    // 	return name ? ` > ${name} ` : ''
    // },
  },
  methods: {
    ...mapMutations({
      SET_CONFIG: 'stationConfig/SET_CONFIG',
      SET_LEVEL: 'stationConfig/SET_LEVEL',
      GET_METERING: 'stationDetail/GET_METERING'
    }),
    ...mapActions({
      GETCRAWLCONFIG: 'stationConfig/GETCRAWLCONFIG',
      GETCRAWSTATS: 'stationConfig/GETCRAWSTATS'
    }),
    getLanguageStr,
      // 获取理论自发自用率
    addShowCalc(data){
    	this.addShowFlag=data;
    },
    getMetering () {
        StationMetering(this.stationId).then(response => {
          this.cumulativeElectricMethod = response.cumulativeElectricMethod
          this.electricityConsumptionMethod = response.electricityConsumptionMethod
          this.electricityPurchaseMethod = response.electricityPurchaseMethod
          this.gridInterconnectionMethod = response.gridInterconnectionMethod
          this.chargingElectricityMethod = response.chargingElectricityMethod
          this.dischargeElectricityMethod = response.dischargeElectricityMethod
        })
    },
    show (config, type, level, id) {
      statistic('A30','A3001')
      if (typeof(type)=='string'){
          this.gridInterconnectionType = type
      }else{
           this.gridInterconnectionType=type.gridInterconnectionType
           if(type.powerType=='PV'){
             type.powerType='light'
           }else{
              type.powerType='wind'
           }
           this.powerType=type.powerType
      }
      if(this.gridInterconnectionType=='EXCESS'){//自发自用余电上网
	    	this.tempCalcBtnList=this.calcBtnList.concat({name:getLanguageStr('plant378','累计用电量计算方法'),key:'useMethods',relationship:1},
      	{name:getLanguageStr('plant381','累计购电量计算方法'),key:'purchaseMethods',relationship:1},
      	{name:getLanguageStr('plant384','累计并网量计算方法'),key:'interconnectionMethods',relationship:1})
      }else if(this.gridInterconnectionType=='BATTERY_BACKUP'){
      	this.tempCalcBtnList=this.calcBtnList.concat({name:getLanguageStr('plant378','累计用电量计算方法'),key:'useMethods',relationship:1},
      	{name:getLanguageStr('plant381','累计购电量计算方法'),key:'purchaseMethods',relationship:1},
      	{name:getLanguageStr('plant384','累计并网量计算方法'),key:'interconnectionMethods',relationship:1},	{name:getLanguageStr('plant387','累计充电量计算方法'),key:'fullMethods',relationship:1},
      	{name:getLanguageStr('plant390','累计放电量计算方法'),key:'dischargeMethods',relationship:1})
      }else{
        this.tempCalcBtnList=this.calcBtnList
      }
      this.stationId = id
         let {generationTotalOffset} = this.metering
         this.globalOffset = generationTotalOffset ? Number(generationTotalOffset) : 0
      // this.requestData.totalOffset = this.requestData.dayOffset = ''
      if (level == 2) {
        this.$nextTick(() => {
          this.$refs.sourceConfig.show(this.stationId)
        })
        // this._configSelect(this.stationId)
      }
      this.$nextTick(() => {
        this.SET_CONFIG(config)
        this.SET_LEVEL(level)
      })
      this.$refs.Window.show()
      this.$refs.Window.loadStatusAction(false)
    },
    // 配置累计发电量偏移量
    configAll (data,type) {
      if(type=='set'){
        this.globalOffset = data
      }
      this.SET_LEVEL(2);
      this.SET_CONFIG({name: getLanguageStr('plant301','偏移量设置'),key:'offset'})
      this.$emit('refreshOffset')
    },
    close () {
      // this.$refs.Window.hide();
      // this.$refs.offsetConfig.reset()
      // this.$refs.sourceConfig.reset()
      // this.$refs.crawl.reset()
      // this.$nextTick(()=>{
      // 	this.$refs.plan.reset()
      // 	this.$refs.proportion.reset()
      // })
    },
    backTopLevel () {
    	if(this.addShowFlag){
    		this.SET_LEVEL(3);
    		this.$refs.offsetConfig.cancelAdd();
    	}else{
    		let config =this.config;
	    	if(config.key=='offsetTotal'||config.key=='offsetDay'){
	    		   this.SET_LEVEL(2)
	    		    this.SET_CONFIG({name: getLanguageStr('plant301','偏移量设置'),key:'offset'})
	    	}else if(config.relationship===1&&config.key!='calcMethods'){
	    		  this.getMetering();
	    		  this.$nextTick(()=>{
	    		  	 this.SET_LEVEL(2)
	    		   	 this.SET_CONFIG({name: getLanguageStr('word1908','累计电量计算方式'),key:'calcMethods',relationship:1})
	    		  })
	    	}else{
	    		 this.SET_LEVEL(1)
	    		 this.SET_CONFIG({})
	    	}
    	}
      // this.$refs.plan.reset()
      // this.$refs.proportion.reset()
      // this.$refs.crawl.reset()
    },
    // 跳转到第二级
    goNext (level, btn) {
      this.SET_LEVEL(level)
      this.SET_CONFIG(btn)
      if(level===2){
      	if (btn.key == 'source') {
        this.$nextTick(() => {
          // this.$refs.sourceConfig.reset()
          this.$refs.sourceConfig.show(this.stationId)
        })
      } else if (btn.key == 'offset') {
        this.$refs.offsetConfig.clear()
	    	if (this.$refs.offsetConfig.activeIndex == 0) {
	          this.typeOf = 'DAY'
	        } else {
	          this.typeOf = 'MONTH'
	        }
	      } else if (btn.key == 'plan') {
	        this.$refs.plan._getPlan(this.stationId)
	      } else if (btn.key == 'python') {
	        this.$refs.crawl.getCrawlConfig()
	      } else if (btn.key == 'proportion') {
	        this.$refs.proportion.reset()
	      }else if (btn.key == 'calcMethods'){
          	this.getMetering()
	    }
      }
      if(level===3&&btn.key==='offsetDay'){
      	this.$refs.offsetConfig.getList()
      }
      if(level===3&&btn.key==='offsetTotal'){
      	this.$refs.offsetConfig.getAll(this.stationId)
      }
    },
    //保存累计发电量计算方法
    saveCalcMethods(){
  	 let methodData={
  	 	cumulativeElectricMethod:this.cumulativeElectricMethod,
  	 	electricityConsumptionMethod:this.electricityConsumptionMethod,
  	 	electricityPurchaseMethod:this.electricityPurchaseMethod,
  	 	gridInterconnectionMethod:this.gridInterconnectionMethod,
  	 	chargingElectricityMethod:this.chargingElectricityMethod,
  	 	dischargeElectricityMethod:this.dischargeElectricityMethod
  	 }
      StationMeteringMethod(this.metering.powerStationId,methodData).then(response => {
      	    this.SET_LEVEL(2)
     		this.SET_CONFIG({name:getLanguageStr('word1823','累计发电量计算方法'),key:'calcMethods',relationship:1})
      }, error => {
        !_.isEmpty(error) && this.$notify(error)
      })
    },
    //取消累计发电量计算方法
    cancelCalcMethods(){
    	    this.getMetering();
   	 	this.SET_LEVEL(2);
     	this.SET_CONFIG({name:getLanguageStr('word1823','累计发电量计算方法'),key:'calcMethods',relationship:1})
    },
    // 实时改变日发电偏移总量
    getTotalData (data) {
      return data.reduce((prev, next) => {
        return prev + next.valueOffset
      }, 0)
    },
    // 获取偏移量列表
//  getOffsetList (sId, time) {
//    this.loadingFlag = true
//    let request = {
//      'type': time
//    }
//    configApi.getGenerationOffsetDayList(sId, request).then(data => {
//      this.dayList = data
//      this.loadingFlag = false
//      this.totalDayOffset = this.getTotalData(data) >= 0 ? `+${this.getTotalData(data)}` : `-${this.getTotalData(data)}`
//    }).catch(error => {
//      this.loadingFlag = false
//      !_.isEmpty(error) && this.$notify(error)
//    })
//  },
    refreshProportion () {
      this.backTopLevel()
      this.$emit('refreshOffset')
    },
    // 刷新爬取数据
    refreshCrawl () {
      this.GETCRAWLCONFIG(this.stationId)
      this.GETCRAWSTATS(this.stationId)
    }
  },
  mounted () {
    lib.setScroll($('#' + this.id + ' [scroll]'))
  }
}
</script>
<style lang="scss" scoped>
.radio-wrap .radio{
  display: block;
}
.transform{
	transform: rotateY(180deg);
	height: 0.6em

}
.config-list{
	li{
		padding-left:1.5em;
		font-size: 1.2em;
		padding-top:1em;
		padding-bottom: 1em;
		border-bottom:1px solid rgba(0, 0, 0, 0.1);
		.flex{
			display: flex;
			align-items: center;
			padding-right:1em;
			.fc1{
				flex: 1;
				padding-left: 1em;
				text-align: right;
				padding-right:1em;
			}
		}
	}
}
.stationId /deep/ .body{
	width: 40%;
}
.flex-1{
	flex:1
}
</style>



// WEBPACK FOOTER //
// src/view/maintain/light/plant/part/StationConfig.vue